import { itemName, itemNameTh, itemTitle, thaiNameState } from '../lib/naming.js';

// ชื่อสินค้าสองบรรทัด: ชื่อจริง (อังกฤษก่อน — ไว้หาของ) + "ไทย: …" (ชื่อสำแดงศุลกากร — ต้องเห็นเสมอ)
// ที่มา: user 28 ต.ค. 69 "ชื่อภาษาไทยยังต้องมีอยู่ ต้องใช้ในเอกสารให้ศุลกากร อย่าเอาออกไป" (ดู naming.js)
//   missing = ใบข้อมูลสินค้า (product_classification) → ชื่อไทยไม่มี / เป็นภาษาอังกฤษ ให้บอกตรง ๆ (ศุลกากรต้องใช้)
export default function NameTh({ c, fallback = '', missing = false }) {
  const th = itemNameTh(c);
  const state = missing && c ? thaiNameState(c) : 'ok';
  return (
    <span className="nm2" title={itemTitle(c)}>
      <span className="nm2-en">{itemName(c, fallback)}</span>
      {th
        ? <span className="nm2-th">ไทย: {th}</span>
        : state === 'empty' ? <span className="nm2-th miss">ยังไม่มีชื่อไทย</span>
        : state === 'english' ? <span className="nm2-th miss">ชื่อไทยยังเป็นภาษาอังกฤษ</span>
        : null}
    </span>
  );
}
